import { Dialog } from "@progress/kendo-react-dialogs";
import * as React from "react";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, NumericTextBox } from "@progress/kendo-react-inputs";
import {
  FormDropDownList,
  FormDropDownListRegion,
  FormDropDownListCountry,
  FormInput,
} from "../../SharedComponents/form-components";
import {
  OPSSegmentValidator,
  TransportationModeValidator,
  RegionModeValidator,
  CountryCodeValidator,
  SCACValidator,
  ContactNameValidator,
  ContactEmailValidator,
  ContactPhoneValidator,
} from "../../SharedComponents/validators";
import {
  Label,
  Error,
  Hint,
  FloatingLabel,
} from "@progress/kendo-react-labels";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useFormUpdate, useFormValue } from "./FormContext";
import "./CarrierContact.scss";

const CarrierContactForm = ({ ddData, item, onSubmit, cancelEdit }) => {
  const {
    region,
    country,
    scac,
    opssegment,
    allCountries,
    transportationMode,
  } = ddData;
  const { type } = item;
  const formRegionValue = useFormValue();
  const formValueUpdate = useFormUpdate();
  const inputRef = React.useRef();

  React.useEffect(() => {
    console.log({ ddData, item, onSubmit, cancelEdit });
    if (type === "edit") {
      const tempRegionValue = ddData["region"].filter(
        (region) => item["geo"] === region["geo"]
      );
      formValueUpdate({ region: tempRegionValue });
    }
  }, []);

  return (
    <Dialog title={type === "add" ? "Add" : "Edit"} onClose={cancelEdit}>
      <Form
        initialValues={item}
        ref={inputRef}
        render={(formRenderProps) => (
          <>
            {/* <div>
              <pre>{JSON.stringify(formRenderProps, null, 2)}</pre>
            </div> */}
            <FormElement style={{ width: "25vw", height: "80vh" }}>
              {/* OPS Segment */}
              <fieldset>
                {type === "add" ? (
                  <Field
                    name={"opsGrp"}
                    component={FormDropDownList}
                    label={"OPS Segment "}
                    data={opssegment}
                    textField={"opsGrp"}
                    validator={OPSSegmentValidator}
                  />
                ) : (
                  <Field
                    name={"opsGrp"}
                    component={FormDropDownList}
                    label={"OPS Segment "}
                    disabled
                  />
                )}
              </fieldset>

              {/* Transportation mode */}
              <fieldset>
                {type === "add" ? (
                  <Field
                    name={"modeTransport"}
                    component={FormDropDownList}
                    label={"Transportation mode "}
                    data={transportationMode}
                    textField={"text"}
                    validator={TransportationModeValidator}
                  />
                ) : (
                  <Field
                    name={"modeTransport"}
                    component={FormDropDownList}
                    label={"Transportation mode "}
                    disabled
                  />
                )}
              </fieldset>

              {/* Region */}
              <fieldset>
                {type === "add" ? (
                  <Field
                    name={"geo"}
                    component={FormDropDownListRegion}
                    label={"Region "}
                    data={region}
                    textField={"geo"}
                  />
                ) : (
                  <Field
                    name={"geo"}
                    component={FormDropDownList}
                    label={"Region "}
                    disabled
                  />
                )}
              </fieldset>

              {/* Country code */}
              <fieldset>
                {type === "add" ? (
                  <Field
                    name={"country"}
                    component={FormDropDownListCountry}
                    label={"Country code "}
                    data={allCountries}
                    textField={"countryName"}
                    validator={CountryCodeValidator}
                  />
                ) : (
                  <Field
                    name={"country"}
                    component={FormDropDownList}
                    label={"Country code "}
                    disabled
                  />
                )}
              </fieldset>

              {/* SCAC */}
              <fieldset>
                {type === "add" ? (
                  <Field
                    name={"scacd"}
                    component={FormDropDownList}
                    label={"SCAC "}
                    data={scac}
                    textField={"text"}
                    validator={SCACValidator}
                  />
                ) : (
                  <Field
                    name={"scacd"}
                    component={FormDropDownList}
                    label={"SCAC "}
                    disabled
                  />
                )}
              </fieldset>

              {/* Contact name */}
              <fieldset>
                <Field
                  name={"contactName"}
                  component={FormInput}
                  label={"Contact name "}
                  validator={ContactNameValidator}
                />
              </fieldset>

              {/* Carrier EmailID */}
              <fieldset>
                <Field
                  name={"contactEmail"}
                  component={FormInput}
                  label={"Carrier EmailID "}
                  validator={ContactEmailValidator}
                />
              </fieldset>

              {/* Carrier PhoneNo */}
              <fieldset>
                <Field
                  name={"contactPhone"}
                  component={FormInput}
                  label={"Carrier PhoneNo "}
                  validator={ContactPhoneValidator}
                />
              </fieldset>

              <div className="k-form-buttons" style={{ paddingBottom: "15px" }}>
                {/* Update */}
                {type === "add" ? (
                  <button
                    type={"submit"}
                    onClick={() => onSubmit(inputRef.current.values)}
                    className="btn k-button k-button-icontext"
                    disabled={
                      !formRenderProps.valid || formRegionValue.region === null
                    }
                  >
                    Update
                  </button>
                ) : (
                  <button
                    type={"submit"}
                    onClick={() => onSubmit(inputRef.current.values)}
                    className="btn k-button k-button-icontext"
                  >
                    Update
                  </button>
                )}

                {/* Cancel */}
                <button
                  type={"submit"}
                  className="btn k-button k-button-icontext rejectbtn"
                  onClick={cancelEdit}
                >
                  Cancel
                </button>
                {/* <div>
                  <pre>{JSON.stringify(item, null, 2)}</pre>
                  <pre>{JSON.stringify(!formRenderProps.valid || formRegionValue.region === null, null, 2)}</pre>
                </div> */}
              </div>
            </FormElement>
          </>
        )}
      />
    </Dialog>
  );
};

export default CarrierContactForm;
